import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';
import { assetPath, company } from '../../data/companyData';

function OffCanvasStyleOne() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
        <div className="side-content-button">
            <Link to="#" variant="primary" className="navSidebar-button" onClick={handleShow}>
                <span className="decor"></span>
                <span className="decor"></span>
                <span className="decor"></span>
            </Link>

            <Offcanvas show={show} onHide={handleClose} className="xs-sidebar-group info-group info-sidebar isActive">
                <div className="xs-overlay xs-bg-black"></div>
                    <div className="xs-sidebar-widget">
                        <div className="sidebar-widget-container">
                            <Offcanvas.Header closeButton className="close-side-widget">
                            </Offcanvas.Header>
                            <div className="sidebar-textwidget">
                                <div className="sidebar-info-contents">
                                    <div className="content-inner">
                                        <div className="logo">
                                            <Link to="/"><img src={assetPath("logo-fa-interior-trim.png")} alt={company.name} style={{maxHeight: "90px", width: "auto"}} /></Link>
                                        </div>
                                        <div className="content-box">
                                            <h4>About Us</h4>
                                            <div className="inner-text">
                                                <p>{company.shortDescription}</p>
                                            </div>
                                        </div>

                                        <div className="form-inner">
                                            <h4>Request a free estimate</h4>
                                            <form action={`mailto:${company.email}`} method="post">
                                                <div className="form-group">
                                                    <input type="text" name="name" placeholder="Name" required="" />
                                                </div>
                                                <div className="form-group">
                                                    <input type="email" name="email" placeholder="Email" required="" />
                                                </div>
                                                <div className="form-group">
                                                    <textarea name="message" placeholder="Message..."></textarea>
                                                </div>
                                                <div className="form-group message-btn">
                                                    <button className="thm-btn" data-text="Send Request +" type="submit" data-loading-text="Please wait...">Send Request</button>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="sidebar-contact-info">
                                            <h4>Contact Info</h4>
                                            <ul>
                                                <li>
                                                    <span className=" icon-maps-and-flags"></span> {company.address}
                                                </li>
                                                <li>
                                                    <span className="icon-phone-call-1"></span>
                                                    <a href={`tel:${company.phoneHref}`}>{company.phone}</a>
                                                </li>
                                                <li>
                                                    <span className="icon-email-1"></span>
                                                    <a href={`mailto:${company.email}`}>{company.email}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="thm-social-link1">
                                            <ul className="social-box">
                                                <li className="facebook">
                                                    <a href={company.social.facebook} aria-label="FA Interior Trim LLC on Facebook" target="_blank" rel="noreferrer">
                                                        <i className="icon-facebook-app-symbol" aria-hidden="true"></i>
                                                        <span style={{position: "absolute", width: "1px", height: "1px", padding: 0, margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0}}>Facebook</span>
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a href={company.social.instagram} aria-label="FA Interior Trim LLC on Instagram" target="_blank" rel="noreferrer">
                                                        <i className="fab fa-instagram" aria-hidden="true"></i>
                                                        <span style={{position: "absolute", width: "1px", height: "1px", padding: 0, margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0}}>Instagram</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Offcanvas>
        </div>
    </>
  );
}

export default OffCanvasStyleOne;
